import { useQuery } from 'data-fetching-client';
import { useMemo } from 'react';
import { GET_VALID_CURRENCIES } from '../rest/queries';
export function usePortalCurrencies() {
  const {
    data
  } = useQuery(GET_VALID_CURRENCIES, {
    fetchPolicy: 'network-only'
  });
  return useMemo(() => {
    const portalCurrencies = data !== null && data !== void 0 && data.currencyData && Array.isArray(data.currencyData) ? data.currencyData : [];
    return {
      supportedCurrencies: portalCurrencies.filter(currency => currency.isProcessorSupportedCurrency),
      allCurrencies: portalCurrencies
    };
  }, [data === null || data === void 0 ? void 0 : data.currencyData]);
}
export function useHasValidPortalCurrency() {
  const {
    supportedCurrencies
  } = usePortalCurrencies();
  return supportedCurrencies.length > 0;
}